/**
 * @module "model/base.model"
 */
define('formkit/model/base.model',['require','exports','module','datakit/datakit'],function(require, exports, module) {
  var DataKit = require('datakit/datakit');

  /**
   * @class BaseModel
   * @augments DataKit.Model
   */
  var BaseModel = DataKit.Model.extend({
    /**
     * @method  serializeChildModel
     * @param   {Object} model
     * @param   {Object} options
     * @returns {Object} the model's attributes
     *
     * @todo The names are a bit confusing and could use a change
     */
    serializeChildModel: function(model, options) {
      return model.toJSON(options);
    },
  });

  module.exports = BaseModel;
});

